var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3404_7835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1713C17.6868 14.6685 23.1758 16.3426 23.1758 16.3426V2.66853C17.6374 -1.60771 12 2.90058 12 2.90058C12 2.90058 6.36264 -1.62428 0.824177 2.66853V16.3426C0.824177 16.3426 6.31319 14.6851 12 17.1713Z",
    stroke: "#0855C9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2912 5.88403C14.2912 5.88403 18.1483 3.74591 20.9835 5.65199",
    stroke: "#0855C9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2912 9.08289C14.2912 9.08289 18.1483 6.94476 20.9835 8.85084",
    stroke: "#0855C9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2912 12.2983C14.2912 12.2983 18.1483 10.1602 20.9835 12.0663",
    stroke: "#0855C9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.0332V16.2266",
    stroke: "#0855C9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3404_7835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryGuide);
export default __webpack_public_path__ + "static/media/EntryGuide.519ddfc309a82234518751e684af3958.svg";
export { ForwardRef as ReactComponent };